import { NumColumns } from '../../grid';

export const TIMESGRID_DESKTOP_CONFIG = {
    MIN_VISIBLE_DAYS: 3,
    MAX_VISIBLE_DAYS: 5,
    SHOULD_SHOW_ALL_ROWS: false,
};

export const TIMESGRID_MOBILE_CONFIG = {
    MIN_VISIBLE_DAYS: 1,
    MAX_VISIBLE_DAYS: 1,
    SHOULD_SHOW_ALL_ROWS: true,
};

export const COMPONENT_SIZE = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
};

export const COMPONENT_SIZE_DEFNS = [
    {
        ID: COMPONENT_SIZE.SMALL,
        MIN_SIZE: 0,
    },
    {
        ID: COMPONENT_SIZE.MEDIUM,
        MIN_SIZE: 420,
    },
    {
        ID: COMPONENT_SIZE.LARGE,
        MIN_SIZE: 567,
    },
];

export const DATE_FORMATS = {
    DISPLAY: 'YYYY-MM-DD',
    DATA_DATE: 'ddd, MMM D',
    DATA_TIME: 'h:mm a',
};

export const SIZE_TO_NUM_COLS = {
    [COMPONENT_SIZE.SMALL]: 3,
    [COMPONENT_SIZE.MEDIUM]: 4,
    [COMPONENT_SIZE.LARGE]: 5,
};

export const DESKTOP_DAY_COLUMN_SIZE = {
    [COMPONENT_SIZE.SMALL]: 6.6666666667,
    [COMPONENT_SIZE.MEDIUM]: 5,
    [COMPONENT_SIZE.LARGE]: 4,
};

/**
 * the arrows always take up 2 grid columns (per "DesktopNavigationToggle" in views/control-primitives.js),
 * so we calculate based on that
 *
 * 100% - both arrow column percent widths - 2 slot margins (4px each)
 */
export const DESKTOP_WIDTH_MATCH_SLOT_AREA = `calc(100% - ${(2 / NumColumns) * 100 * 2}% - 8px)`;
